module.exports = __webpack_public_path__ + "2020celebration/img/s1.f0c0ade6.png";